// scroll bar
import 'simplebar/dist/simplebar.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lightgallery used to be imported here as three CSS files and three SCSS
// partials. Nothing in src/ imports the lightgallery JS or references an `lg-*`
// class, so all six were dead weight in the global stylesheet on every page —
// and they are what produced the "Failed to parse source map" warnings on every
// build. If a gallery is ever added, import its styles next to the component
// rather than globally here.

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

//
import { store, persistor } from './redux/store';
//
import LoadingScreen from './components/loading-screen';
//
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <BrowserRouter>
          {/* <AuthProvider> */}
          <App />
          {/* </AuthProvider> */}
        </BrowserRouter>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
